<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WsEnmi/images/e9781439633502_cover.jpg?1684514748472" alt="This image is the cover for the book Mid-South Fair: Celebrating 150 Years, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mid-South Fair: Celebrating 150 Years, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Established in 1856 by the Shelby County Agricultural Society, the Mid-South Fair celebrates its 150th anniversary in 2006. Memphis, known as the cotton capital of the South, depended on agriculture for much of the 19th century, and the fair offered farmers and the general public a venue to learn of new products and to compete with others from the region. Through the Civil War, yellow fever epidemics, and two world wars, the fair has prevailed to become one of the largest in the nation. It has been a part of many lives and formed many memories of rides and rodeos, cotton candy and pronto pups, and that first big drop on the roller coaster. The Mid-South Fair: Celebrating 150 Years brings back those memories through words and photographs, taking the reader back to a time when excitement was only a ride away on an old wooden roller coaster.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert W. Dye, 
      </h2>
      
      <p class="authorDescription body article">Robert W. Dye is a lifelong Memphian who has worked to document the visual history of Memphis and the surrounding area. Author of Then & Now: Memphis and Images of America: Shelby County, Mr. Dye is currently the chairman of the Mid-South Fair Historical Committee and a member of the Shelby County Historical Commission.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e58505a6